import { useState, useEffect } from 'react'
import { debounce } from 'es-toolkit'

const useAnchorPosition = (sectionIds: string[], offset = 100) => {
  const [activeId, setActiveId] = useState(sectionIds[0] || '')

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = Math.ceil(window.scrollY + offset + 10)

      let foundActiveId = false

      // 遍历所有section，找到当前可视区域内的section
      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionIds[i])
        if (section) {
          const offsetTop = Math.ceil(section.getBoundingClientRect().top + window.scrollY)
          if (scrollPosition >= offsetTop) {
            setActiveId(sectionIds[i])
            foundActiveId = true
            break
          }
        }
      }

      // 如果滚动距离小于第一个section的offset，设置为第一个section
      if (!foundActiveId && sectionIds.length > 0) {
        setActiveId(sectionIds[0])
      }
    }

    // 初始化时执行一次
    handleScroll()

    // 创建debounce函数并保存引用，确保能正确移除监听器
    const debouncedHandleScroll = debounce(handleScroll, 50)
    window.addEventListener('scroll', debouncedHandleScroll)

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [sectionIds, offset])

  return activeId
}

export default useAnchorPosition
